/**
 *
 * @param {string} parameterNameNeedle, the key you want to have the value returned from
 * @returns {boolean|string} Returns the false if not found and a string with the value if found
 */
export default function getUrlParameter(parameterNameNeedle) {
	var pageUrl = window.location.search.substring(1),
		URLVariables = pageUrl.split('&'),
		parameterName,
		i

	for (i = 0; i < URLVariables.length; i++) {
		parameterName = URLVariables[i].split('=')

		if (parameterName[0] === parameterNameNeedle) {
			return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1])
		}
	}
	return false
}
